<template>
  <div>
    <el-card>
      <div class="cardBody">
          <el-row>
            <el-row>
              <el-col :span="18"><div class="title" @click="openPost()">{{post.Titulo}}</div></el-col>
              <el-col :span="4">
                <el-row>
                  <el-col :span="10"><div class="mensajes" @click="openPost()"><i class="el-icon-chat-line-square"></i></div></el-col>
                  <el-col :span="14"><div class="mensajes" @click="openPost()">{{post.CantidadComentarios}}</div></el-col>
                </el-row>
              </el-col>
              <el-col :span="2" v-if="this.post.Instancia != 'Z' && this.idUsuario == this.post.Usuario.Id && this.isHome != true">
                <div class="mensajes" @click="archivar()">
                  <el-tooltip class="item" effect="dark" :content="$t('FORO_archivar')" placement="left-start">
                      <i class="el-icon-folder-opened "></i>
                  </el-tooltip>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24"><div class="descripcion">{{post.Descripcion}}</div></el-col>
            </el-row>
          </el-row>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: "foroCard",
  props: {
    post: Object,
    isHome: Boolean,
  },
  data() {
    return {
      activeNames: ["1"],
      loading: false,
    };
  },
    computed: {
    ...mapState({
        idUsuario: state => state.sesion.resultadoAutenticacion.IdUsuario,
      })
    },
  methods: {
    openPost()
      {
        this.$emit('openPost', this.post.Id)
      },
      archivar()
      {
        this.$emit('archivar', this.post.Id)
      },
  },
}
</script>

<style scoped>
.title {
  font-size: 16px;
  line-height: 19px;
  font-weight: bold;
  margin-bottom: 15px;
  display: inline-block;
  width: 70%;
}
.mensajes {
  display: inline-block;
  width: 30%;
  text-align: center;
  position: relative;
  top: -5px;
  left: 10px;
  font-size: 20px;
  line-height: 23px;
  color: #838383;
}
.descripcion {
  font-size: 14px;
  line-height: 18px;
  color: #5a5a5a;
}
</style>
